import { Injectable } from '@angular/core';
import countries from "../../../../assets/demo/data/countries.json";
import { UserControlService } from '../userControl/user-control.service';
import { BehaviorSubject } from 'rxjs';
import { Base64 } from 'js-base64';

@Injectable({
  providedIn: 'root'
})
export class UtilityService {


  permissions: any;
  constructor(private userService :  UserControlService) {
    this.userService.$userFeatures.subscribe((featureList: any) => {
      if (featureList) {
        this.permissions = featureList;
      }
    })
  }

  public getCountryList(): any {
    return countries.map((country: any) => {
      return {
        key: country.name,
        value: country.name
      }
    });
  }

  public getRandomNo(min: number = 999999999, max: number = 9999999999) {
    min = Math.ceil(min);
    max = Math.floor(max);
    return Math.floor(Math.random() * (max - min + 1)) + min;
  }

  public static convertToBase64(value: string) {
    return Base64.encode(value);
  }
  public static convertFromBase64(value: string): any {
    return JSON.parse(Base64.decode(value));
  }

  public hasPrivilege(feature: string, privilege: string): boolean {
    const featurePermission = this.permissions?.features?.find((perm: any) => perm.featureKey === feature) || null;
    return featurePermission?.privileges?.some((priv: any) => priv.privilegeKey === privilege) || false;
  }
}
